import { render, staticRenderFns } from "./certificateAdd.vue?vue&type=template&id=5474951a&"
import script from "./certificateAdd.vue?vue&type=script&lang=js&"
export * from "./certificateAdd.vue?vue&type=script&lang=js&"
import style0 from "./certificateAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports